// istanbul ignore file
import React, { useState } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Checkbox, FormControlLabel, Typography, Divider, DialogContent } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ModelPopup from '../../../components/Modal'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import { getHeaderSummaryRegisterAssetDashboardService, getHeaderSummaryKPIAssetDashboardService, getAssetPerformanceKPIDataDashboardService, getAssetPerformanceDataDashboardService, getAlertTrendKPIDataDashboardService, getAlertTrendRegisterDataDashboardService } from '../redux/actionCreator'
import { type HeaderSummaryAssetRegisterDataState } from '../redux/getAssetDashboardHeaderRegisterSummarySlice'
import { type HeaderSummaryAssetKPIDataState } from '../redux/getAssetDashboardHeaderKPISummarySlice'
import { type AssetPerformanceDataState } from '../redux/getAssetPerformanceDataSlice'
import { type AssetPerformanceKPIDataState } from '../redux/getAssetPerformanceKPIDataSlice'
import { updateSaveDefaultObject } from '../../../utils/updateSaveDefaultObject'
import { type AlertTrendAseetKPIDataState } from '../redux/getAlertTrendAssetKPIDataSlice'
import { type AlertTrendRegisterDataState } from '../redux/getAlertTrendRegisterDataSlice'
import { DEFAULT_DATA_PERFORMANCE_WINDOW_HOURS, DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'
import dayjs from 'dayjs'
import refresh from '../../../assets/refresh.svg'

const NestedMenuWithCheckboxes = (props: AllProps): JSX.Element => {
  const [checkedItems, setCheckedItems] = useState<Record<string, { Id: string, parameterName: string, checked: boolean }>>({})
  const [showSuccessPopUp, setshowSuccessPopUp] = React.useState(false)
  const [selectedData, setSelectedData] = React.useState<string>('')
  const [selectedRegisterData, setSelectedRegisterData] = React.useState<any>('')
  const [selectedKPIData, setSelectedKPIData] = React.useState<any>('')
  const [selectedDefaultData, setSelectedDefaultData] = React.useState<any>()
  const Menudata = useSelector((state: RootState) => state.parameterTree.menuInfo) ?? []
  const saveDefaultViewObject = useSelector((state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject)
  const GetDeviceParameters = useSelector((state: RootState) => state.getParameterConfigurationData)
  const dashboardHours = DEFAULT_DATA_WINDOW_HOURS
  const performanceDefaultHours = DEFAULT_DATA_PERFORMANCE_WINDOW_HOURS

  const assetRegisterSummaryData = useSelector((state: RootState) => state.headerSummaryRegisterAssetData.headerSummaryAssetRegisterData
  )
  const assetKPISummaryData = useSelector((state: RootState) => state.headerSummaryKPIAssetData?.headerSummaryAssetKPIData)
  const [clearButton, setClearButton] = React.useState(false)
  // Merge devices from both KPI and Register sources by device_id
  const mergeDevices = (
    kpiDevices: any[] = [],
    registerDevices: any[] = []
  ): any[] => {
    const deviceMap: Record<string, any> = {}

    // Add KPI devices
    kpiDevices.forEach(device => {
      const id = device.device_id ?? device.deviceId ?? ''
      if (typeof id !== 'string' || id === '') return
      deviceMap[id] = {
        device_id: id,
        device_name: device.device_name ?? device.deviceName ?? '',
        kpi_data: device.kpi_data ?? device.kpiData ?? [],
        register_readings: []
      }
    })

    // Merge Register devices
    registerDevices.forEach(device => {
      const id = device.device_id ?? device.deviceId ?? ''
      if (typeof id !== 'string' || id === '') return
      if (deviceMap[id] === undefined || deviceMap[id] === null) {
        deviceMap[id] = {
          device_id: id,
          device_name: device.device_name ?? device.deviceName ?? '',
          kpi_data: [],
          register_readings: device.register_readings ?? device.registerReadings ?? []
        }
      } else {
        deviceMap[id].register_readings =
            device.register_readings ?? device.registerReadings ?? []
      }
    })

    return Object.values(deviceMap)
  }

  const summaryData = {
    asset_id: assetKPISummaryData?.asset_id ?? assetRegisterSummaryData?.asset_id ?? '',
    asset_name: assetKPISummaryData?.asset_name ?? assetRegisterSummaryData?.asset_name ?? '',
    tenant_id: assetKPISummaryData?.tenant_id ?? assetRegisterSummaryData?.tenant_id ?? '',
    assetKPIs: assetKPISummaryData?.assetKPIs ?? [],
    devices: mergeDevices(assetKPISummaryData?.devices, assetRegisterSummaryData?.devices)
  }

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const filteredMenuData = Menudata?.map((company: any) => ({
    ...company,
    site: {
      ...company.site,
      assetList: company.site.assetList
        .filter((asset: any) => asset.id === props.CurrentAssetID)
        .map((asset: any) => ({
          ...asset,
          gateway: asset?.gateway?.filter((gateway: any) => gateway.id)
        }))
    }
  })).filter((company: any) => company.site.id === props.currentSiteID && company.site.assetList.length > 0) || []

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string, defaultPerformanceDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(dashboardHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    const defaultPerformanceDataWindowUTC = utcDate.utc().subtract(performanceDefaultHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC, defaultPerformanceDataWindowUTC }
  }

  const defaultParam = JSON.stringify({
    assetId: props.CurrentAssetID,
    devices: []
  })

  const defaultParamKPI = JSON.stringify({
    assetId: props.CurrentAssetID,
    devices: [],
    assets: []
  })

  React.useEffect(() => {
    const { today, defaultDataWindowUTC, defaultPerformanceDataWindowUTC } = getUtcDateRange()
    switch (props.graphName) {
      case 'assetStatus':
        if (props.applyButton && (selectedRegisterData !== '' || selectedKPIData !== '' || selectedData !== '')) {
          props.getHeaderSummaryRegisterAssetDashboardService(props.currentSiteID, props.CurrentAssetID, props.graphName, selectedRegisterData, props.isdefault)
          props.getHeaderSummaryKPIAssetDashboardService(props.currentSiteID, props.CurrentAssetID, props.graphName, selectedKPIData, props.isdefault)
          updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, props.graphName)
        } else if ((clearButton && props.applyButton && (selectedRegisterData === '' || selectedKPIData === ''))) {
          props.getHeaderSummaryRegisterAssetDashboardService(props.currentSiteID, props.CurrentAssetID, props.graphName, selectedRegisterData === '' ? null : selectedRegisterData, props.isdefault)
          props.getHeaderSummaryKPIAssetDashboardService(props.currentSiteID, props.CurrentAssetID, props.graphName, selectedKPIData === '' ? null : selectedKPIData, props.isdefault)
        }
        break
      case 'assetPerformance':
        if (props.applyButton && (selectedRegisterData !== '' || selectedKPIData !== '') && props.startDate !== '' && props.endDate !== '') {
          props.getAssetPerformanceDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedRegisterData, props.isdefault)
          props.getAssetPerformanceKPIDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedKPIData, props.isdefault)
          updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, props.graphName)
        } else if (props.applyButton && (selectedRegisterData !== '' || selectedKPIData !== '') && props.startDate === '' && props.endDate === '') {
          props.getAssetPerformanceDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedRegisterData, props.isdefault)
          props.getAssetPerformanceKPIDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedKPIData, props.isdefault)
          updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, props.graphName)
        } else if (clearButton && props.applyButton && (selectedRegisterData === '' || selectedKPIData === '')) {
          props.getAssetPerformanceDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedRegisterData, props.isdefault)
          props.getAssetPerformanceKPIDataDashboardService(defaultPerformanceDataWindowUTC, today, props.graphName, selectedKPIData, props.isdefault)
          updateSaveDefaultObject(saveDefaultViewObject, {
            widgetId: props.graphName,
            displayname: props.graphName,
            devices: [],
            assets: []
          }, props.graphName)
        } else if (!clearButton && props.applyButton && (selectedRegisterData === '' || selectedKPIData === '') && props.startDate === '' && props.endDate === '') {
          props.getAssetPerformanceDataDashboardService(defaultDataWindowUTC, today, props.graphName, defaultParam, true)
          props.getAssetPerformanceKPIDataDashboardService(defaultDataWindowUTC, today, props.graphName, defaultParamKPI, true)
        }
        break
      case 'assetAlertTrend':
        if (props.applyButton && (selectedRegisterData !== '' || selectedKPIData !== '') && props.startDate !== '' && props.endDate !== '') {
          if (props.range != null) {
            props.getAlertTrendRegisterDataDashboardService(props.startDate, props.endDate, props.graphName, selectedRegisterData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
            props.getAlertTrendKPIDataDashboardService(props.startDate, props.endDate, props.graphName, selectedKPIData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
          }
          updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, props.graphName)
        } else if (props.applyButton && (selectedRegisterData !== '' || selectedKPIData !== '') && props.startDate === '' && props.endDate === '') {
          if (props.range != null) {
            props.getAlertTrendRegisterDataDashboardService(defaultDataWindowUTC, today, props.graphName, selectedRegisterData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
            props.getAlertTrendKPIDataDashboardService(defaultDataWindowUTC, today, props.graphName, selectedKPIData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
            updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, props.graphName)
          }
        } else if (clearButton && props.applyButton && (selectedRegisterData === '' || selectedKPIData === '')) {
          if (props.range != null) {
            props.getAlertTrendRegisterDataDashboardService(defaultDataWindowUTC, today, props.graphName, selectedRegisterData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
            props.getAlertTrendKPIDataDashboardService(defaultDataWindowUTC, today, props.graphName, selectedKPIData, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, props.isdefault)
            updateSaveDefaultObject(saveDefaultViewObject, {
              widgetId: props.graphName,
              displayname: props.graphName,
              devices: [],
              assets: []
            }, props.graphName)
          }
        } else if (!clearButton && props.applyButton && (selectedRegisterData === '' || selectedKPIData === '') && props.startDate === '' && props.endDate === '') {
          if (props.range != null) {
            props.getAlertTrendRegisterDataDashboardService(defaultDataWindowUTC, today, props.graphName, defaultParam, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, true)
            props.getAlertTrendKPIDataDashboardService(defaultDataWindowUTC, today, props.graphName, defaultParamKPI, `${props.range.selectedTime},${props.range.timezone},${props.range.status}`, true)
          }
        }
        break
      default:
        break
    }
  }, [props.applyButton, selectedDefaultData])

  React.useEffect(() => {
    setCheckedItems({})
    setSelectedData('')
  }, [clearButton])

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, item: { Id: string, parameterName: string, parentId: string }): void => {
    const uniqueKey = `${item.parentId}-${item.Id}`
    if (props.graphName === 'assetStatus') {
      setCheckedItems((prevCheckedItems) => {
        const newCheckedItems = {
          ...prevCheckedItems,
          [uniqueKey]: {
            Id: item.Id,
            parameterName: item.parameterName,
            checked: event.target.checked
          }
        }
        const checkedCount = Object.values(newCheckedItems).filter(item => item.checked).length

        if (checkedCount > 5) {
          setshowSuccessPopUp(true)
          return prevCheckedItems
        }

        const response = generateResponse(newCheckedItems)
        const formattedResponse = {
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds,
              kpidefinitionIds: item.kpiDefinitionIds
            })),
          assets: response
            .filter(item => item.assetId)
            .map(item => ({
              assetId: item.assetId,
              kpidefinitionIds: item.assetKpiDefinitionIds
            }))
        }

        const formattedResponseRegister = {
          devices: response
            .filter(item => item.deviceId != null && Array.isArray(item.cimCodeIds) && item.cimCodeIds.length > 0)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds
            }))
        }

        const formattedResponseKPI = {
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              kpidefinitionIds: item.kpiDefinitionIds
            })),
          assets: response
            .filter(item => item.assetId)
            .map(item => ({
              assetId: item.assetId,
              kpidefinitionIds: item.assetKpiDefinitionIds
            }))
        }

        setSelectedDefaultData({
          widgetId: props.graphName,
          displayname: props.graphName,
          devices: formattedResponse.devices,
          assets: formattedResponse.assets
        })
        setSelectedData(JSON.stringify(formattedResponse))
        setSelectedRegisterData(formattedResponseRegister)
        setSelectedKPIData(formattedResponseKPI)
        return newCheckedItems
      })
    } else if (props.graphName === 'assetPerformance') {
      setCheckedItems((prevCheckedItems) => {
        const newCheckedItems = {
          ...prevCheckedItems,
          [uniqueKey]: {
            Id: item.Id,
            parameterName: item.parameterName,
            checked: event.target.checked
          }
        }
        const checkedCount = Object.values(newCheckedItems).filter(item => item.checked).length

        if (checkedCount > 8) {
          setshowSuccessPopUp(true)
          return prevCheckedItems
        }

        const response = generateResponse(newCheckedItems)
        const formattedResponse = {
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds,
              kpidefinitionIds: item.kpiDefinitionIds
            }))
        }

        const formattedResponseRegister = {
          assetId: props.CurrentAssetID,
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds,
              kpidefinitionIds: []
            }))
        }

        const formattedResponseKPI = {
          assetId: props.CurrentAssetID,
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: [],
              kpidefinitionIds: item.kpiDefinitionIds
            })),
          assets: response
            .filter(item => item.assetId)
            .map(item => ({
              assetId: item.assetId,
              kpidefinitionIds: item.assetKpiDefinitionIds
            }))
        }
        setSelectedDefaultData({
          widgetId: props.graphName,
          displayname: props.graphName,
          devices: formattedResponse.devices,
          assets: formattedResponseKPI.assets
        })
        setSelectedData(JSON.stringify(formattedResponse))
        setSelectedRegisterData(JSON.stringify(formattedResponseRegister))
        setSelectedKPIData(JSON.stringify(formattedResponseKPI))
        return newCheckedItems
      })
    } else if (props.graphName === 'assetAlertTrend') {
      setCheckedItems((prevCheckedItems) => {
        const newCheckedItems = {
          ...prevCheckedItems,
          [uniqueKey]: {
            Id: item.Id,
            parameterName: item.parameterName,
            checked: event.target.checked
          }
        }
        const checkedCount = Object.values(newCheckedItems).filter(item => item.checked).length

        if (checkedCount > 4) {
          setshowSuccessPopUp(true)
          return prevCheckedItems
        }

        const response = generateResponse(newCheckedItems)
        const formattedResponse = {
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds,
              kpidefinitionIds: item.kpiDefinitionIds
            }))
        }
        const formattedResponseRegister = {
          assetId: props.CurrentAssetID,
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: item.cimCodeIds,
              kpidefinitionIds: []
            }))
        }

        const formattedResponseKPI = {
          assetId: props.CurrentAssetID,
          devices: response
            .filter(item => item.deviceId)
            .map(item => ({
              deviceId: item.deviceId,
              cimCodeIds: [],
              kpidefinitionIds: item.kpiDefinitionIds
            })),
          assets: response
            .filter(item => item.assetId)
            .map(item => ({
              assetId: item.assetId,
              kpidefinitionIds: item.assetKpiDefinitionIds
            }))
        }

        setSelectedDefaultData({
          widgetId: props.graphName,
          displayname: props.graphName,
          devices: formattedResponse.devices,
          assets: formattedResponseKPI.assets
        })

        setSelectedData(JSON.stringify(formattedResponse))
        setSelectedRegisterData(JSON.stringify(formattedResponseRegister))
        setSelectedKPIData(JSON.stringify(formattedResponseKPI))
        localStorage.setItem('formattedResponseRegister', JSON.stringify(formattedResponseRegister))
        localStorage.setItem('formattedResponseKPI', JSON.stringify(formattedResponseKPI))
        return newCheckedItems
      })
    }
  }

  const generateResponse = (checkedItems: Record<string, { Id: string, parameterName: string, checked: boolean }>): Array<{ assetId?: string, deviceId?: string, cimCodeIds: string[], kpiDefinitionIds: string[], assetKpiDefinitionIds: string[] }> => {
    const response: Array<{ assetId?: string, deviceId?: string, cimCodeIds: string[], kpiDefinitionIds: string[], assetKpiDefinitionIds: string[] }> = []

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const assetKpiDefinitionIds = GetDeviceParameters?.parameters?.assetKPIs?.filter((kpi: any) => checkedItems[`${props.CurrentAssetID}-${kpi?.kpiDefinitionId}`]?.checked)
      .map((kpi: any) => kpi.kpiDefinitionId) ?? []

    if (assetKpiDefinitionIds.length > 0) {
      response.push({
        assetId: props.CurrentAssetID,
        cimCodeIds: [],
        kpiDefinitionIds: [],
        assetKpiDefinitionIds
      })
    }

    GetDeviceParameters?.parameters?.gateway?.forEach((gateway: any) => {
      gateway?.device?.forEach((device: any) => {
        const cimCodeIds = device.registers
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          .filter((register: any) => checkedItems[`${device.id}-${register.cimCodeId}`]?.checked)
          .map((register: any) => register.cimCodeId)

        const kpiDefinitionIds = device.kpis
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          .filter((kpi: { kpiDefinitionId: string }) => checkedItems[`${device.id}-${kpi.kpiDefinitionId}`]?.checked)
          .map((kpi: any) => kpi.kpiDefinitionId)

        if (cimCodeIds.length > 0 || kpiDefinitionIds.length > 0) {
          response.push({
            deviceId: device.id,
            cimCodeIds,
            kpiDefinitionIds,
            assetKpiDefinitionIds: []
          })
        }
      })
    })

    return response
  }

  React.useEffect(() => {
    compareAndSetDefaultCheckedItems()
  }, [summaryData !== undefined && summaryData !== null, props.graphName])

  const compareAndSetDefaultCheckedItems = (): void => {
    const newCheckedItems: Record<string, { Id: string, parameterName: string, checked: boolean }> = {}
    if (summaryData != null && props.graphName === 'assetStatus') {
      GetDeviceParameters?.parameters?.gateway?.forEach((gateway: any) => {
        gateway?.device?.forEach((device: any) => {
          device.registers.forEach((register: any) => {
            const summaryDevice = summaryData?.devices?.find((d: any) => d.device_id === device.id)
            if (summaryDevice != null) {
              const summaryReading = summaryDevice.register_readings?.find((reading: any) => reading.cimCodeId === register.cimCodeId)
              if (summaryReading != null) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                newCheckedItems[`${device.id}-${register.cimCodeId}`] = {
                  Id: register.cimCodeId,
                  parameterName: register.parameterName,
                  checked: true
                }
              }
            }
          })
          device.kpis.forEach((kpi: any) => {
            const summaryDevice = summaryData.devices?.find((d: any) => d.device_id === device.id)
            if (summaryDevice != null) {
              const summaryKpi = summaryDevice.kpi_data.find((k: { kpi_definition_id: string }) => k.kpi_definition_id === kpi.kpiDefinitionId)
              if (summaryKpi !== undefined && summaryKpi !== null) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                newCheckedItems[`${String(device.id)}-${String(kpi.kpiDefinitionId)}`] = {
                  Id: kpi.kpiDefinitionId,
                  parameterName: kpi.parameterName,
                  checked: true
                }
              }
            }
          })
        })
      })
      GetDeviceParameters?.parameters?.assetKPIs?.forEach((kpi: any) => {
        const summaryKpi = summaryData.assetKPIs?.find((k: { kpi_definition_id: string }) => k.kpi_definition_id === kpi.kpiDefinitionId)
        if (summaryKpi !== undefined && summaryKpi !== null) {
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          newCheckedItems[`${props.CurrentAssetID}-${kpi.kpiDefinitionId}`] = {
            Id: kpi.kpiDefinitionId,
            parameterName: kpi.parameterName,
            checked: true
          }
        }
      })
    } else if (props.graphName === 'assetPerformance') {
      GetDeviceParameters?.parameters?.gateway?.forEach((gateway: any) => {
        gateway?.device?.forEach((device: any) => {
          device.registers.forEach((register: any) => {
            if (props.assetPerformanceData.AssetPerformanceData !== null && Array.isArray(props.assetPerformanceData.AssetPerformanceData)) {
              const summaryDevice = props.assetPerformanceData.AssetPerformanceData.find((d: any) => d.deviceId === device.id)
              if (summaryDevice != null) {
                const summaryReading = summaryDevice.registerReadings.find((reading: any) => reading.cimCodeId === register.cimCodeId)
                if (summaryReading != null) {
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  newCheckedItems[`${device.id}-${register.cimCodeId}`] = {
                    Id: register.cimCodeId,
                    parameterName: register.parameterName,
                    checked: true
                  }
                }
              }
            }
          })
          device.kpis.forEach((kpi: any) => {
            if (props.AssetPerformanceKPIData.AssetPerformanceKPIData?.deviceKPIReadings !== null && Array.isArray(props.AssetPerformanceKPIData.AssetPerformanceKPIData?.deviceKPIReadings)) {
              const summaryDevice = props.AssetPerformanceKPIData?.AssetPerformanceKPIData?.deviceKPIReadings.find((d: any) => d.deviceId === device.id)
              if (summaryDevice != null) {
                const summaryKpi = summaryDevice.kpiReadings.find((k: any) => k.kpiDefinitionId === kpi.kpiDefinitionId)
                if (summaryKpi !== undefined && summaryKpi !== null) {
                  newCheckedItems[`${String(device.id)}-${String(kpi.kpiDefinitionId)}`] = {
                    Id: kpi.kpiDefinitionId,
                    parameterName: kpi.parameterName,
                    checked: true
                  }
                }
              }
            }
          })
          GetDeviceParameters?.parameters?.assetKPIs?.forEach((kpi: any) => {
            if (props.AssetPerformanceKPIData.AssetPerformanceKPIData?.assetKPIReadings !== null && Array.isArray(props.AssetPerformanceKPIData.AssetPerformanceKPIData?.assetKPIReadings)) {
              const summaryKpi = props.AssetPerformanceKPIData?.AssetPerformanceKPIData?.assetKPIReadings.flatMap((asset: any) => asset.kpiReadings).find((k: { kpiDefinitionId: string }) => k.kpiDefinitionId === kpi.kpiDefinitionId)
              if (summaryKpi !== undefined && summaryKpi !== null) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                newCheckedItems[`${props.CurrentAssetID}-${kpi.kpiDefinitionId}`] = {
                  Id: kpi.kpiDefinitionId,
                  parameterName: kpi.parameterName,
                  checked: true
                }
              }
            }
          })
        })
      })
    } else if (props.graphName === 'assetAlertTrend') {
      GetDeviceParameters?.parameters?.gateway?.forEach((gateway: any) => {
        gateway?.device?.forEach((device: any) => {
          device.registers.forEach((register: any) => {
            if (props.alertTrendRegisterAssetDashboard.AlertTrendRegisterDataAssetDashboard !== null && Array.isArray(props.alertTrendRegisterAssetDashboard.AlertTrendRegisterDataAssetDashboard)) {
              const summaryDevice = props.alertTrendRegisterAssetDashboard.AlertTrendRegisterDataAssetDashboard.find((d: any) => d.deviceId === device.id)
              if (summaryDevice != null) {
                const summaryReading = summaryDevice.paraMeterReadings.find((reading: any) => reading.paraMeterId === register.cimCodeId)
                if (summaryReading != null) {
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  newCheckedItems[`${device.id}-${register.cimCodeId}`] = {
                    Id: register.cimCodeId,
                    parameterName: register.parameterName,
                    checked: true
                  }
                }
              }
            }
          })
          device.kpis.forEach((kpi: any) => {
            if (props.alertTrendKPIAssetDashboard.AlertTrendKPIDataAssetDashboard?.deviceReadings !== null && Array.isArray(props.alertTrendKPIAssetDashboard.AlertTrendKPIDataAssetDashboard?.deviceReadings)) {
              const summaryDevice = props.alertTrendKPIAssetDashboard?.AlertTrendKPIDataAssetDashboard?.deviceReadings.find((d: any) => d.deviceId === device.id)
              if (summaryDevice != null && summaryDevice !== undefined) {
                const summaryKpi = summaryDevice?.paraMeterReadings?.find((reading: any) => reading.paraMeterId === kpi.kpiDefinitionId)
                if (summaryKpi !== undefined && summaryKpi !== null) {
                  newCheckedItems[`${String(device.id)}-${String(kpi.kpiDefinitionId)}`] = {
                    Id: kpi.kpiDefinitionId,
                    parameterName: kpi.parameterName,
                    checked: true
                  }
                }
              }
            }
          })
          GetDeviceParameters?.parameters?.assetKPIs?.forEach((kpi: any) => {
            if (props.alertTrendKPIAssetDashboard.AlertTrendKPIDataAssetDashboard?.assetReadings !== null && Array.isArray(props.alertTrendKPIAssetDashboard?.AlertTrendKPIDataAssetDashboard?.assetReadings)) {
              const summaryKpi = props.alertTrendKPIAssetDashboard?.AlertTrendKPIDataAssetDashboard?.assetReadings.flatMap((asset: any) => asset.paraMeterReadings).find((k: { paraMeterId: string }) => k.paraMeterId === kpi.kpiDefinitionId)
              if (summaryKpi !== undefined && summaryKpi !== null) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                newCheckedItems[`${props.CurrentAssetID}-${kpi.kpiDefinitionId}`] = {
                  Id: kpi.kpiDefinitionId,
                  parameterName: kpi.parameterName,
                  checked: true
                }
              }
            }
          })
        })
      })
    }
    setCheckedItems(newCheckedItems)
  }

  const handleOkandClose = (): void => {
    setshowSuccessPopUp(false)
  }

  const handleClearButton = (widget = 'none'): void => {
    setClearButton(!clearButton)
    if (widget === 'assetAlertTrend') {
      const emptyData = {
        widgetId: 'assetAlertTrend',
        displayname: 'assetAlertTrend',
        devices: [],
        assets: []
      }
      updateSaveDefaultObject(saveDefaultViewObject, emptyData, 'assetAlertTrend')
    } else if (widget === 'assetPerformance') {
      const emptyData = {
        widgetId: 'assetPerformance',
        displayname: 'assetPerformance',
        devices: [],
        assets: []
      }
      updateSaveDefaultObject(saveDefaultViewObject, emptyData, 'assetPerformance')
    } else if (widget === 'assetStatus') {
      const emptyData = {
        widgetId: 'assetStatus',
        displayname: 'assetStatus',
        devices: [],
        assets: []
      }
      updateSaveDefaultObject(saveDefaultViewObject, emptyData, 'assetStatus')
    }
  }

  return (
    <>
     <span onClick={() => { handleClearButton(props.graphName) }} style={{ color: '#64C3FF', cursor: 'pointer' }}><img src={refresh} height={20} width={20} style={{ marginLeft: '23px', marginRight: '6px', paddingTop: '3px' }} />   Clear all</span>
     <Divider sx={{ backgroundColor: '#272727', border: '3px solid #272727', margin: '10px 0px' }} />
     <DialogContent>
      <div className="nested-menu-asset">
        {filteredMenuData.map((company: any) => (
        <Accordion style={{ backgroundColor: '#252525', color: '#f2f2f2' }} key={company.site.id} defaultExpanded>
          {/* <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ order: -1, color: '#f2f2f2' }} />}>
          <Typography>{company.companyName}</Typography>
          </AccordionSummary> */}
          <AccordionDetails>
          {company.site.assetList.map((asset: any) => (
            <Accordion style={{ backgroundColor: '#252525', color: '#f2f2f2' }} key={asset.id} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ order: -1, color: '#f2f2f2' }} />}>
              <Typography>{asset.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {GetDeviceParameters?.parameters?.assetKPIs
                ?.filter((kpi: any) => !(props.graphName === 'assetAlertTrend' && kpi?.isTotalizer === true))
                .map((kpi: any) => (
                <FormControlLabel style={{ display: 'block' }}
                  key={kpi.kpiDefinitionId}
                  control={
                  <Checkbox
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  checked={checkedItems[`${asset.id}-${kpi.kpiDefinitionId}`]?.checked || false}
                  onChange={(e) => { handleCheckboxChange(e, { Id: kpi.kpiDefinitionId, parameterName: kpi.parameterName, parentId: asset.id }) }}
                  sx={{
                    color: '#f2f2f2',
                    marginTop: '-5px'
                  }}
                  />
                  }
                  label={kpi.parameterName}
                />
                ))}
              {GetDeviceParameters?.parameters?.gateway?.map((gateway: any) => (
              <Accordion style={{ backgroundColor: '#252525', color: '#f2f2f2' }} key={gateway.id} defaultExpanded>
                <AccordionDetails>
                {gateway?.device?.map((device: any) => (
                  <Accordion style={{ backgroundColor: '#252525', color: '#f2f2f2' }} key={device.id} defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ order: -1, color: '#f2f2f2' }} />}>
                    <Typography>{device.name}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {device.registers.map((register: any) => (
                    <FormControlLabel style={{ display: 'block' }}
                      key={register.cimCodeId}
                      control={
                      <Checkbox
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        checked={checkedItems[`${device.id}-${register.cimCodeId}`]?.checked || false}
                        onChange={(e) => { handleCheckboxChange(e, { Id: register.cimCodeId, parameterName: register.parameterName, parentId: device.id }) }}
                        sx={{
                          color: '#f2f2f2',
                          marginTop: '-5px'
                        }}
                      />
                      }
                      label={register.parameterName}
                    />
                    ))}
                      {device.kpis
                        .filter((kpi: { isTotalizer: boolean }) => !(props.graphName === 'assetAlertTrend' && kpi.isTotalizer))
                        .map((kpi: any) => (
                      <FormControlLabel style={{ display: 'block' }}
                        key={kpi.kpiDefinitionId}
                        control={
                        <Checkbox
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        checked={checkedItems[`${device.id}-${kpi.kpiDefinitionId}`]?.checked || false}
                        onChange={(e) => { handleCheckboxChange(e, { Id: kpi.kpiDefinitionId, parameterName: kpi.parameterName, parentId: device.id }) }}
                        sx={{
                          color: '#f2f2f2',
                          marginTop: '-5px'
                        }}
                        />
                        }
                        label={kpi.parameterName}
                      />
                        ))}
                  </AccordionDetails>
                  </Accordion>
                ))}
                </AccordionDetails>
              </Accordion>
              ))}
            </AccordionDetails>
            </Accordion>
          ))}
          </AccordionDetails>
        </Accordion>
        ))}
        {showSuccessPopUp && (
        <ModelPopup buttonTypeNegative='hollow'
          title={'Parameter Selection'}
          LabelPositive={'Ok'}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
        { props.graphName === 'assetPerformance'
          ? (
          <p style={{ paddingTop: '1.2em' }}>
            {'Please select only 8 parameters'}
          </p>
            )
          : props.graphName === 'assetAlertTrend'
            ? (
            <p style={{ paddingTop: '1.2em' }}>
              {'Please select only 4 parameters'}
            </p>
              )
            : (
          <p style={{ paddingTop: '1.2em' }}>
            {'Please select only 5 parameters'}
          </p>
              )}
        </ModelPopup>
        )}
      </div>
    </DialogContent>
    </>
  )
}

interface DispatchToProps {
  getAssetPerformanceDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getAssetPerformanceKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
  getHeaderSummaryRegisterAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getHeaderSummaryKPIAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => void

}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getAssetPerformanceDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getAssetPerformanceDataDashboardService(startDate, endDate, graphName, requestParams, isdefault)),
  getAssetPerformanceKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getAssetPerformanceKPIDataDashboardService(startDate, endDate, graphName, requestParams, isdefault)),
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendKPIDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault)),
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendRegisterDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault)),
  getHeaderSummaryRegisterAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getHeaderSummaryRegisterAssetDashboardService(siteId, assetId, graphName, requestParams, isdefault)),
  getHeaderSummaryKPIAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getHeaderSummaryKPIAssetDashboardService(siteId, assetId, graphName, requestParams, isdefault))
})

interface StateToProps {
  headerSummaryAssetRegisterData: HeaderSummaryAssetRegisterDataState
  headerSummaryAssetKPIData: HeaderSummaryAssetKPIDataState
  assetPerformanceData: AssetPerformanceDataState
  AssetPerformanceKPIData: AssetPerformanceKPIDataState
  alertTrendRegisterAssetDashboard: AlertTrendRegisterDataState
  alertTrendKPIAssetDashboard: AlertTrendAseetKPIDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  headerSummaryAssetRegisterData: state.headerSummaryRegisterAssetData,
  headerSummaryAssetKPIData: state.headerSummaryKPIAssetData,
  assetPerformanceData: state.assetPerformanceData,
  AssetPerformanceKPIData: state.AssetPerformanceKPIData,
  alertTrendRegisterAssetDashboard: state.alertTrendRegisterAssetDashboard,
  alertTrendKPIAssetDashboard: state.alertTrendKPIAssetDashboard
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface currentDeviceID {
  currentSiteID: string
  CurrentAssetID: string
  graphName: string
  applyButton: boolean
  isdefault: boolean
  startDate: string
  endDate: string
  range?: {
    selectedTime: string
    timezone: string
    status: string
  }
  displayName?: string
}

type AllProps = PropsFromRedux & currentDeviceID

export default connector(NestedMenuWithCheckboxes)
